import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import {
  apiRequest,
  ServiceBase,
} from 'services';

import { FlightSchedule } from '@models/acceptshedule';
import { FlightBooking } from '@models/flight-booking-model';
import { SellRecommendationQuery } from '@models/SellRecommendationQuery';

@Injectable({
    providedIn: 'root'
})

export class FlightBookService extends ServiceBase {
    SELLREQUESTSTATUS: Subject<any>;
    BOOKINGSUCCESS: Subject<any>;
    paypalSuccess$: Subject<any>;
    retryBookSuccess$: Subject<any>;
    seatMapSuccess$: Subject<any>;
    ancillarySuccess$: Subject<any>;
    AcceptSchedule$: Subject<any>;
    postBookAncilariesSuccess$: Subject<any>;
    documentSuccess$: Subject<any>;
    ancillarySuccessForOtherSupplier$: Subject<any>;
    ancillaryPurchaseSuccess$: Subject<any>;
    razorSuccess$: Subject<any>;
    constructor(http: HttpClient) {
        super(http);

        this.SELLREQUESTSTATUS = new Subject();
        this.BOOKINGSUCCESS = new Subject();
        this.paypalSuccess$ = new Subject();
        this.retryBookSuccess$ = new Subject();
        this.seatMapSuccess$ = new Subject();
        this.ancillarySuccess$ = new Subject();
        this.AcceptSchedule$ = new Subject();
        this.postBookAncilariesSuccess$ = new Subject<any>();
        this.documentSuccess$ = new Subject<any>();
        this.ancillaryPurchaseSuccess$ = new Subject<any>();
        this.razorSuccess$ = new Subject();
    }

    sellRequest(data: SellRecommendationQuery) {
        this.post<boolean>({ url: 'flights/flight/v1/SellRequest', data: data, onNotify: this.SELLREQUESTSTATUS, operationKey: 'sell' } as apiRequest<boolean>);
    }

    bookFlight(data: FlightBooking) {
        this.post<boolean>({
            url: 'flightbook/flight/v1/FlightBooking', data: data, onNotify: this.BOOKINGSUCCESS,
            handleErrorThroughSubject: true,
            operationKey: 'book'
        } as apiRequest<boolean>);
        // this.post<boolean>( {url: 'flights/flight/v1/AmadeusBooking', data: data,onNotify: this.BOOKINGSUCCESS,operationKey:'book' } as apiRequest<boolean>);

    }

    makePaypalPayment(paymentDetails) {
        return this.post({ url: "Payments/PayPal/MakePayment", data: paymentDetails, onNotify: this.paypalSuccess$ })
    }
    makeRazorPayment(rzpayment) {
        return this.post({ url: "Payments/RazorPay/Authorize", data: rzpayment, onNotify: this.razorSuccess$ })
    }
    // This end point is optional , to be used only for testing environment ... 
    retryFlightBook(retryObj) {
        this.post<boolean>({ url: 'flights/flight/v1/RetryAmadeusBooking', data: retryObj, onNotify: this.retryBookSuccess$, operationKey: 'retry' } as apiRequest<boolean>);
    }

    getSeatMap(seatmapObj) {
        this.post<boolean>({ url: 'flightbook/flight/v1/SeatMapDetails', data: seatmapObj, onNotify: this.seatMapSuccess$, 
        handleErrorThroughSubject: true,
        
        operationKey: 'seatmap' } as apiRequest<boolean>);
    }

    getPreBookingAncillary(prebookObj) {
        this.post<boolean>({ url: 'flightbook/flight/v1/AncillaryService', data: prebookObj, onNotify: this.ancillarySuccess$, 
        handleErrorThroughSubject: true,
        
        operationKey: 'ancillary' } as apiRequest<boolean>);
    }

    getPreBookingAncillaryForOtherSupplier(prebookObj) {
        this.post<boolean>({ url: 'flightbook/flight/v1/PreBookingDetails', data: prebookObj,
        handleErrorThroughSubject: true,
        
        onNotify: this.
        
        ancillarySuccessForOtherSupplier$, operationKey: 'ancillary' } as apiRequest<boolean>);
    }

    acceptfShedule(acceptdata: FlightSchedule) {
        return this.post({ url: "flightbook/flight/v1/CustomerAcceptedOrRejectedScheduleChange", data: acceptdata, onNotify: this.AcceptSchedule$ })
    }

    /**
     * 
     * @param ancilaryObj 
     * This function is used to get post book ancilaries
     */
    getPostBookAncillaries(ancilaryObj) {
        return this.post({ url: "flightbook/flight/v1/PostAncillaryService", data: ancilaryObj, onNotify: this.postBookAncilariesSuccess$ })
    }


    getMandatoryDocument(documentObj) {
        this.post<boolean>({ url: 'flightbook/flight/v1/CheckMandatoryDocument', data: documentObj, onNotify: this.documentSuccess$, 
        handleErrorThroughSubject: true,
        
        operationKey: 'seatmap' } as apiRequest<boolean>);
    }

    // bookPostAncillary(ancillaryobj) {
    //     return this.post({ url: 'flightbook/flight/v1/PostAncillaryBookingService', data: ancillaryobj, onNotify: this.ancillaryPurchaseSuccess$, operationKey: 'postbook' }) as apiRequest<boolean>);
    // }


    bookPostAncillary(ancillaryobj) {
        return this.post<boolean>({
            url: 'flightbook/flight/v1/PostAncillaryBookingService',
            data: ancillaryobj,
            onNotify: this.ancillaryPurchaseSuccess$,
            handleErrorThroughSubject: true,
            operationKey: 'Ancillary_Book'
        } as apiRequest<boolean>);
    }

}